import { Navigate, useLocation } from "react-router-dom";
import {
  SIGN_IN_PATH,
  SIGN_UP_PATH,
} from "@/lib/auth-routes";

/**
 * `/auth` and `/auth?mode=signup` were the original combined auth page. Links to
 * them are still in the wild — password-reset emails already delivered, saved
 * bookmarks, external campaigns — so the path stays routed and forwards to the
 * dedicated page.
 *
 * The hash matters: Supabase recovery and confirmation links arrive as
 * `#access_token=…&type=recovery`, and dropping it would strand the user on a
 * sign-in form with no way to set their password.
 */
export function LegacyAuthRedirect() {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const isSignUp = params.get("mode") === "signup";
  params.delete("mode");
  const search = params.toString();

  return (
    <Navigate
      to={{
        pathname: isSignUp ? SIGN_UP_PATH : SIGN_IN_PATH,
        search: search ? `?${search}` : "",
        hash: location.hash,
      }}
      state={location.state}
      replace
    />
  );
}
